import { configureStore, combineReducers } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import thunk from 'redux-thunk'
import { persistStore } from 'redux-persist'
import persistReducer from 'redux-persist/es/persistReducer'
import sessionStorage from 'redux-persist/es/storage/session'

import userReducer from './user/user.slice'
import addolcitoreReducer from './addolcitore/addolcitore.slice'

const persistConfig = {
    key: 'root',
    storage: sessionStorage
    }

const reducers = combineReducers({//aggiungere qui i prossimi reducers
    user: userReducer,
    addolcitore: addolcitoreReducer
})

const persistedReducer = persistReducer(persistConfig, reducers)

const middlewares = [thunk]

if(process.env.NODE_ENV === 'development')//in production non và mostrato
    middlewares.push(logger)  

const store = configureStore({
    reducer: persistedReducer,
    middleware: middlewares,
    devTools: process.env.NODE_ENV !== 'production',
})

export default store
export const persistor = persistStore(store)